/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentTranslationRequestDto } from './contentTranslationRequestDto';

export interface ContentRequestDto {
  id: string;
  type: ContentRequestDto.TypeEnum;
  translations: Array<ContentTranslationRequestDto>;
}
// tslint:disable-next-line:no-namespace
export namespace ContentRequestDto {
  export type TypeEnum = 'term_and_condition' | 'privacy' | 'about_us' | 'contact_us' | 'pdpa' | 'cookie_policy';
  export const TypeEnum = {
      TermAndCondition: 'term_and_condition' as TypeEnum,
      Privacy: 'privacy' as TypeEnum,
      AboutUs: 'about_us' as TypeEnum,
      ContactUs: 'contact_us' as TypeEnum,
      Pdpa: 'pdpa' as TypeEnum,
      CookiePolicy: 'cookie_policy' as TypeEnum,
  };
}
